import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../config/axios';

const AdminLogin = () => {
  const [email, setEmail] = useState('admin@janvahan.com');
  const [password, setPassword] = useState('123456');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Attempting login to:', '/admin/login');
      
      const response = await axios.post('/admin/login', { 
        email, 
        password 
      });
      
      console.log('Login response:', response.data);
      
      if (response.data.token) {
        const { token, user } = response.data;
        
        // Store admin token with clear naming
        localStorage.setItem('admin_token', token);
        localStorage.setItem('admin_user', JSON.stringify(user));
        
        // Also set the default token for axios
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        console.log('Token stored:', localStorage.getItem('admin_token'));
        console.log('User stored:', localStorage.getItem('admin_user'));
        console.log('User role:', user.role);
        
        // Force redirect to dashboard
        window.location.href = '/admin/dashboard';
        
      } else {
        setError('Invalid response from server');
      }
      
    } catch (error) {
      console.error('Login error details:', error);
      
      if (error.response?.status === 401) {
        setError('Invalid email or password');
      } else if (error.response?.status === 403) {
        setError('Access forbidden. Admin privileges required.');
      } else if (error.response?.status === 404) {
        setError('API endpoint not found. Please check your backend configuration.');
      } else if (error.code === 'ERR_NETWORK') {
        setError('Cannot connect to server. Please check if the backend is running.');
      } else if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">
            <span className="text-red-600">JAN</span>VAHAN
          </h1>
          <p className="text-gray-600 mt-2">Admin Panel Login</p>
        </div>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 disabled:opacity-50 transition"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;